import { render } from "./ChooseAccount.vue?vue&type=template&id=328c55a2"
import script from "./ChooseAccount.vue?vue&type=script&lang=js"
export * from "./ChooseAccount.vue?vue&type=script&lang=js"

import "./ChooseAccount.vue?vue&type=style&index=0&id=328c55a2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__